const PageUtil = {
    pageNo: 1,
    pageSize: 10
}

export default PageUtil